import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/Binconsolidation';
/*import Table from '../../Tables/DataTable/components/DataTable';*/
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const BinconsolidationConfirmation = ({ t }) => (
  <Container>
    <Row>
      <Col md={8}>
        <h3 className="page-title">Bin Consolidation Confirmation</h3>
      </Col>
	  <Col md={4}>
        <a onClick={() => {window.location.href = "/maintenance/BinconsolidationDashboard"}} color="primary" class="button_enable " style={{color:'rgb(112, 187, 253)', cursor:'pointer', textDecoration: 'underline',padding:'10px',display:'block'}}>Back to Bin Consolidation Dashboard</a>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

BinconsolidationConfirmation.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(BinconsolidationConfirmation);
